/**
 * InfoList
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card, ListGroup } from 'react-bootstrap';
import cx from 'utils/cx.js';

function InfoList(props) {
  const { title, items, showItem, control, className } = props;
  return (
    <Card className={cx('border-0', className)}>
      <Card.Header className="d-flex justify-content-between align-items-baseline px-0 pb-2">
        <h3 className="card-title"><FormattedMessage {...title} /></h3>
        {control}
      </Card.Header>
      <ListGroup variant="flush" className="border-bottom">
        {items.map((item) => (
          <ListGroup.Item key={item.id} className="px-0">{showItem(item)}</ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
}

InfoList.propTypes = {
  title: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  showItem: PropTypes.func.isRequired,
  control: PropTypes.node,
  className: PropTypes.string,
};

export default InfoList;
